module.exports = __webpack_public_path__ + "static/media/drive_file_move.f36b04cb.svg";